export interface NewStreamConfig {
  stream: {
    id: string;
    displayName: string;
    enabled: boolean;
    taxonomy: {
      workflowTypes: any[];
    };
    productDefinitions: any[];
    teamDefinitions: any[];
    tenantDefinitions: any[];
    roles: any[];
    tools: any[];
    prompts: Record<string, any>;
  };
}

export function buildNewStreamConfig(streamId: string, displayName?: string): NewStreamConfig {
  const normalizedStreamId = streamId.trim();
  const normalizedDisplayName = displayName?.trim() || normalizedStreamId;

  return {
    stream: {
      id: normalizedStreamId,
      displayName: normalizedDisplayName,
      enabled: true,
      taxonomy: {
        workflowTypes: [],
      },
      productDefinitions: [],
      teamDefinitions: [],
      tenantDefinitions: [],
      roles: [],
      tools: [],
      prompts: {},
    },
  };
}
